import { useNavigate, useLocation } from "react-router-dom";

import { Button } from "@components/Button";
import { ButtonSize } from "@components/Button/types";
import { MainLayout } from "@components/MainLayout";
import { Routes } from "@ctypes";
import { i18n, Translations } from "@i18n";
import { ContributorList } from "./ContributorList";
import { InviteContactList } from "./InviteContactList";
import { ShareGoalRouteParams } from "./types";

export const ShareGoalRoute = () => {
  const location = useLocation();

  const goalId = (location.state as ShareGoalRouteParams).goalId;

  const navigate = useNavigate();

  const handleInvite = () => {
    navigate(Routes.ShareGoalContact, { state: { goalId } });
  };

  return (
    <MainLayout pageHeader={i18n.t(Translations.ShareGoalRouteTitle)}>
      <ContributorList />
      <InviteContactList />

      <Button
        title={i18n.t(Translations.ShareGoalRoutePrimaryCTA)}
        size={ButtonSize.Small}
        onClick={handleInvite}
      />
    </MainLayout>
  );
};
